import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@cmsgov/ds-medicare-gov'

import openLiveChat from '../../utils/openLiveChat'
import { sendTealiumClickEvent, ClickEventOptions } from '../../utils/sendTealiumEvent'

import { CATEGORIES } from '../../constants/analytics.json'

export interface LiveChatMenuProps {
  isAuthenticated: boolean;
  openChatAsPopup: boolean;
}

export const LiveChatMenu: React.FC<LiveChatMenuProps> = ({ isAuthenticated, openChatAsPopup }) => {
  const { t } = useTranslation('liveChat')

  const trackClickEvent = () => {
    const options: ClickEventOptions = {
      logged_in: isAuthenticated,
      text: t('buttonText'),
      target_location: 'Open live chat',
      heading: 'Chat',
      category: CATEGORIES.PERSONAL_NAV
    }

    sendTealiumClickEvent(options)
  }

  const handleLiveChatClick = () => {
    openLiveChat(isAuthenticated, openChatAsPopup)
    trackClickEvent()
  }

  return (
    <div className='ch-c-livechat-menu'>
      <p className='ds-text ds-u-margin-bottom--3'>{t('message')}</p>
      <Button title='Live Chat - Opens in a new window' className='ds-c-button--primary-alt' data-testid='live-chat-btn' onClick={handleLiveChatClick} type='button'>{t('buttonText')}</Button>
    </div>
  )
}
